// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { arbitraryObjectGuard, configurableConnectorMetadataGuard } from '../foundations/index.js';
const createGuard = z.object({
    id: z.string().max(128),
    enabled: z.boolean().optional(),
    syncProfile: z.boolean().optional(),
    connectorId: z.string().max(128),
    config: arbitraryObjectGuard.optional(),
    metadata: configurableConnectorMetadataGuard.optional(),
    createdAt: z.number().optional(),
});
const guard = z.object({
    id: z.string().max(128),
    enabled: z.boolean(),
    syncProfile: z.boolean(),
    connectorId: z.string().max(128),
    config: arbitraryObjectGuard,
    metadata: configurableConnectorMetadataGuard,
    createdAt: z.number(),
});
export const Connectors = Object.freeze({
    table: 'connectors',
    tableSingular: 'connector',
    fields: {
        id: 'id',
        enabled: 'enabled',
        syncProfile: 'sync_profile',
        connectorId: 'connector_id',
        config: 'config',
        metadata: 'metadata',
        createdAt: 'created_at',
    },
    fieldKeys: [
        'id',
        'enabled',
        'syncProfile',
        'connectorId',
        'config',
        'metadata',
        'createdAt',
    ],
    createGuard,
    guard,
});
